module.exports = __webpack_public_path__ + "static/media/EasyWords_ios_2_preview.ff1b9366.jpg";